<template>
    <div class="c-o-my-pages-section">
        <div
            class="c-o-my-pages-section__inner c-o-my-pages-section__inner--large"
        >
            <div class="o-wysiwyg">
                <h2 class="c-o-my-pages-section__heading">Förfrågningar</h2>
                <!-- <p>Nedan listas dina förfrågningar. Klicka på rubriken för att se vilka hantverkare (maximalt 6 st) som har besvarat en förfrågan.</p> -->
                <p>Klicka på din förfrågan nedan för att:</p>
                <ul>
                    <li>Se vilka hantverkare som besvarat din förfrågan</li>
                    <li>
                        Be om avtalsförslag från den hantverkare du vill anlita
                        (endast möjligt för tjänsten TryggtJobb)
                    </li>
                    <li>
                        Lämna ett omdöme på hantverkaren när arbetet är utfört
                    </li>
                </ul>
                <div class="u-margin-vertical-2">
                    <status-pill :status="'direct'">TryggtJobb</status-pill>
                    - innebär att du får ett skriftligt avtal från hantverkaren
                    som ni båda signerar digitalt via BraByggare. För att få ett
                    avtalsförslag från hantverkaren går du in på din förfrågan
                    och klickar på “Be om avtalsförslag”.
                </div>
                <div class="u-margin-bottom-2">
                    <atom-button
                        class="c-m-card__button c-a-button--small c-a-button--circle c-a-button--theme-success c-a-button--inactive"
                        :icon="'check'"
                    ></atom-button>
                    - Klicka på symbolen bredvid din förfrågan för att
                    inaktivera den. Gör din förfrågan inaktiv så snart du valt
                    en hantverkare eller när jobbet inte längre är aktuellt.
                </div>
            </div>
            <div>
                <requests-list-table
                    :isMatched="true"
                    :requests="requests"
                    :emptyState="{
                        body:
                            'Det finns inga förfrågningar att visa här. Kom tillbaka senare.',
                        icon: ''
                    }"
                    @toggleStatus="toggleStatus($event)"
                ></requests-list-table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

import { TOGGLE_REQUEST_STATUS } from "../../../../../../store/store-models/my-pages-customer-model";

import AtomButton from "../../../../atoms/AtomButton.vue";
import StatusPill from "../../../../atoms/AtomStatus.vue";
import ErrorState from "../../../../molecules/MoleculeErrorState.vue";
import Loader from "../../../../molecules/MoleculeLoader.vue";
import RequestsListTable from "../../../OrganismRequestsListCustomerTable.vue";

export default {
    components: {
        RequestsListTable,
        AtomButton,
        StatusPill,
        Loader,
        ErrorState
    },
    props: {
        requests: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        ...mapActions({
            toggleStatus: TOGGLE_REQUEST_STATUS
        })
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/customer/requests/OrganismMyPagesRequestsListCustomer.vue